import React, { useEffect, useState } from "react"
import { useInvoicesPaymentsContext } from "~/contexts/InvoicePaymentsProvider"
import { DotLottieReact } from "@lottiefiles/dotlottie-react"
import Button from "~/components/ui/Button"

const ProcessingPayment: React.FC = () => {
  const { paymentMethod, paymentSuccess } = useInvoicesPaymentsContext()
  const [showSuccess, setShowSuccess] = useState<boolean>(false)
  const [showReturnButton, setShowReturnButton] = useState<boolean>(false)

  useEffect(() => {
    if (paymentSuccess) {
      setShowSuccess(true)
    }
  }, [paymentSuccess])

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowReturnButton(true)
    }, 2000)

    return () => clearTimeout(timer)
  }, [])

  const getProcessingMessage = () => {
    if (showSuccess) {
      return "Payment successful! Redirecting you to your invoice..."
    }

    if (paymentMethod === "us_bank_account") {
      return "Your bank payment is being processed. This may take 1-3 business days to complete. We'll update this page automatically when your payment is confirmed."
    } else {
      return "Your payment is being processed. This page will update automatically when complete."
    }
  }

  const handleReturnClick = () => {
    window.location.reload()
  }

  return (
    <div className="flex flex-col items-center justify-center p-8 text-center w-full min-h-[calc(100vh-20rem)]">
      <div className="relative w-[120px] h-[120px] overflow-hidden">
        <DotLottieReact
          src={"https://lottie.host/a6aaf708-40b1-4dda-8eb5-20c44242f6ab/hg4nYMV8ms.lottie"}
          autoplay
          style={{
            width: "300px",
            height: "300px",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)"
          }}
          speed={0.8}
        />
      </div>
      <h2 className="text-xl font-semibold pt-10">{showSuccess ? "Payment Successful" : "Payment Processing"}</h2>
      <p className="text-gray-600 pb-6">{getProcessingMessage()}</p>

      <div className="h-10">
        <div className={`transition-all duration-500 ease-in-out transform ${showReturnButton ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-4'}`}>
          {showReturnButton && (
            <Button
              variant="blue"
              onClick={handleReturnClick}
            >
              Return to Invoice
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default ProcessingPayment
